'use strict';

module Patersons {

    export class FeaturedItemComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/research/components/featuredItem.component.html';
        bindings: any = {
            feedItem: '<',
            showImage: '<',
            defaultImage: '@',
            title: '@'
        };
    }
}
